import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { SubscriptionBloc } from '@kbloc';
import { DataLinkBloc } from '@kp/data-link/data-link.bloc';
import { DataStoreService } from '@kservice';
import { Status } from '@ktypes/models';
import { Observable, of } from 'rxjs';
import { map, skipWhile } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CheckSubscriptionStatusGuard {
  constructor(
    private dataStoreService: DataStoreService,
    private subscriptionBloc: SubscriptionBloc,
    private router: Router
  ) {}

  canActivate(/*route: ActivatedRouteSnapshot, state: RouterStateSnapshot*/): Observable<boolean | UrlTree> | boolean {
    if (DataLinkBloc.isExternalPulseSurvey) {
      return true;
    }
    if ((this.dataStoreService.authData?.user?.group?.subscriptionPlans ?? []).length > 0) {
      this.subscriptionBloc.getSubscriptionStatus();
      return this.subscriptionBloc.subscriptionStatus$.pipe(
        map((subStatus) => {
          if (subStatus?.status === Status.done) {
            return subStatus.data?.access || this.router.parseUrl('/welcome');
          }
          return null;
        }),
        skipWhile((subStatus) => {
          return subStatus == null;
        })
      );
    } else {
      return of(true);
    }
  }
}
